import { Badge, Button, Card, Empty, Select, Space, Table, Tabs } from 'antd';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import Breadcrumb, { Route } from 'antd/lib/breadcrumb/Breadcrumb';
import { Feature, Product, ProductVersionModel } from '../../models/product-interface';
import { ProductQueries } from '../../queries/product-queries';
import { cancel } from '../../utilites/api';
import { ShortDateStringForUser } from '../../utilites/dateTimeHelper';
import moment from 'moment';
import { Link } from 'react-router-dom';
import ProductFeatures from './detail/tabs/ProductFeatures';
import { profile } from 'console';
import ProductCompanies from './detail/tabs/ProductCompanies';
import { CustomerServiceQueries } from '../../queries/customer-service-queries';
import ProductSupport from './detail/tabs/ProductSupport';


const { TabPane } = Tabs;
const { Option } = Select;

interface RouteParams {
  productId: string;
}


function ProductDetail() {

    const { productId } = useParams<RouteParams>();
    const productQuery = ProductQueries.useProductDetail(Number(productId));
    const newVersionQuery = ProductQueries.useAddProductVersion(Number(productId))
    const [activeKey,setActiveKey] = useState<string>("features");
    const isLoading = productQuery.isLoading;
    const history = useHistory();
    const [currentVersion, setCurrentVersion] = useState<number>(0);
    const [isDraftState, setIsDraftState] = useState<boolean>(false);
    const [draftFeatureList, setDraftFeatureList] = useState<Feature[]>([]);
    

    useEffect(() => {
        document.title = `Govenda CS: Product`
    }, []);

    useEffect(() => {
        if(currentVersion === 0 && !!productQuery?.data) {
            setCurrentVersion(productQuery.data[0].versionId)
        }
    },[productQuery.data])

    const version = ():ProductVersionModel => {
        if(!!productQuery.data) {
            if(currentVersion > 0) {
                return productQuery.data?.find(x => x.versionId == currentVersion)
            } else {
                return productQuery.data[0]
            }
        } else {
            return null
        }
    }

    const tabList = !!productQuery.data ? [
    {
        key: 'features',
        tab: "Features"
    },
    {
        key: "support",
        tab: "Support"
    },
    {
        key: 'companies',
        tab: <>Companies <Badge count={version()?.companies.length ?? 0} /></>
    }
    ] : []
    

    
  const columns: any = [
    {
      title: 'Product ID',
      dataIndex: 'id',
      key: 'productId',
      render: (id: number, record: Product) => {
        return (id
        )
      },
      hidden: false,
      sorter: {
        compare: (a: Product, b: Product) =>
          a.id === b.id ? 0 : a.id > b.id ? -1 : 1
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (name: string, record: Product) => {
        return (
          <Button
            type="link"
            href={`/admin/product/${record.id}`}
            onClick={(e) => {
              e.preventDefault();
              history.push(`/admin/product/${record.id}`)
            }}
          >
            {name}
          </Button>
        )
      },
      hidden: false,
      sorter: {
        compare: (a: Product, b: Product) =>
          a.name.localeCompare(b.name)
      },
    },
    
    {
        title: 'Type',
        dataIndex: 'category',
        key: 'category',
        render: (category: string, record: Product) => {
          return (category)
        },
        hidden: activeKey !== "legacy",
        sorter: {
          compare: (a: Product, b: Product) =>
            a.category.localeCompare(b.category)
        },
      },
    {
      title: 'Current Version',
      dataIndex: 'version',
      key: 'version',
      render: (version: number, record: Product) => {
        return (
          version
        )
      },
      hidden: false,
      sorter: {
        compare: (a: Product, b: Product) =>
        a.version === b.version ? 0 : a.version > b.version ? -1 : 1
      },
    },
    {
      title: 'Last Updated',
      dataIndex: 'updated_date',
      key: 'updated_date',
      hidden: false,
      render: (date?: Date) => {
        return date !== null ? ShortDateStringForUser(date, 1) : null;
        },
        sorter: { 
            compare: (a: { updated_date: moment.MomentInput; }, b: { updated_date: moment.MomentInput; }) => moment(a.updated_date).diff(moment(b.updated_date))
        },
    },
  ];

  /**
   * Breadcrumb routes
   */
   const routes: Route[] = [
    {
        path: "/admin/products",
        breadcrumbName: 'Products'
    },
    {
        path: "",
        breadcrumbName: version()?.product.name ?? "Product"
    },
  ]

  /**
     * Bread crumb item render
     * @param route 
     * @param _ 
     * @param routes 
     * @returns 
     */
   const itemRender = (route, _, routes) => {
    if (routes.indexOf(route) === routes.length - 1)
        return <Breadcrumb.Item>{route.breadcrumbName}</Breadcrumb.Item>
    return <Link to={route.path}>{route.breadcrumbName}</Link>
}

  const canCreateVersion = ():boolean => {
    var data = productQuery?.data
    var current = !!data ? data[0] : null
    if(!!current) {
        return current.companies.length > 0
    }
  }

  const versionSelectItems = () => {
      var data = productQuery?.data
    var i = !!data ? data[0].versionId : 1
    var current = i
    var items: JSX.Element[] = []
    
    while(i > 0) {
        items.push(<Option key={`version-${i}`} value={`${i}`}>Version {i}{current == i ? " (Current)":""}</Option>)
        i--;
    }

    return items
  }

  const createNewVersion = () => {
    var data = {
      features: draftFeatureList,
      companies: [],
      versionId: productQuery.data[0].versionId + 1,
      product: productQuery.data[0].product,
      date: new Date()
    }

    newVersionQuery.mutateAsync(data).then(() => {
      setIsDraftState(false);
      setCurrentVersion(data.versionId);
    })
  }

  const extras = [(
    <Space key={"header-buttons"}>
      {!isDraftState && (<>
        <Button type='primary' onClick={() => setIsDraftState(true)} disabled={!canCreateVersion()}>Draft New Version</Button>
        <Select value={`${currentVersion}`} onChange={v => setCurrentVersion(Number(v))}>{versionSelectItems()}</Select>
      </>
      )}
      {isDraftState && (<>
          <Button onClick={() => setIsDraftState(false)}>Cancel</Button>
          <Button type='primary' onClick={() => createNewVersion()}>Create Version</Button>
        </>
      )}
    </Space>
  )]

  const content = !!version() ? [<ProductFeatures 
    product={version()}
    visible={true}
    isDrafting={isDraftState}
    draftFeatureList={draftFeatureList}
    setDraftFeatureList={setDraftFeatureList}
  />,
  <ProductSupport 
  product={version()}
  visible={true}
  />,
  <ProductCompanies 
  product={version()}
  allProductVersions={productQuery.data}
  visible={true}
/>] : []

  return <>
  <Breadcrumb routes={routes} itemRender={itemRender} /><br/>
  <Card 
    loading={isLoading} 
    title={version()?.product.name} 
    tabList={tabList} 
    extra={extras}
    activeTabKey={activeKey} onTabChange={key => {
                    setActiveKey(key);
                }}>
                    {!!version() ? content[activeKey === "features" ? 0 : activeKey === "companies" ? 2 : activeKey === "support" ? 1 : 0] : null}
                
    
  </Card></>
}


export default ProductDetail;